import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const loc = useLocation();
  const sessionId = sp.get("session_id");
  const { t, lang } = useI18n();
  const [status, setStatus] = useState("polling");
  const [rec, setRec] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setRec(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
      } catch (err) {
        console.warn("Payment status poll failed", err);
      }
      if (attempts < 20) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
    // `api`/setters are stable; only `sessionId` should re-poll.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const isReg = loc.pathname.includes("registration");
  return (
    <div className="max-editorial container-x py-24 text-center max-w-2xl">
      {status === "paid" ? (
        <>
          <div className="label-mono text-terracotta">{isReg ? "Tilmelding bekræftet" : "Donation modtaget"}</div>
          <h1 data-testid="thank-you-heading" className="font-editorial text-5xl md:text-6xl mt-4 tracking-tighter">{t("thank_you_t")}</h1>
          <p className="mt-4 text-ink/70">{t("thank_you_sub")}</p>
          {rec && (
            <p className="mt-2 text-ink/50 text-sm">
              {Number(rec.amount).toLocaleString(lang === "en" ? "en-DK" : "da-DK")} {rec.currency?.toUpperCase()}
            </p>
          )}
          <div className="mt-12 flex justify-center gap-3 flex-wrap">
            <Link to="/impact" data-testid="thanks-impact" className="border border-ink hover:bg-ink hover:text-base px-6 py-3 transition-colors">{t("nav_impact")}</Link>
            <Link to="/get-involved" data-testid="thanks-getinvolved" className="border border-ink hover:bg-ink hover:text-base px-6 py-3 transition-colors">{t("nav_get_involved")}</Link>
            <Link to="/" className="border border-ink hover:bg-ink hover:text-base px-6 py-3 transition-colors">{t("back")}</Link>
          </div>
        </>
      ) : status === "polling" ? (
        <>
          <div className="label-mono">Behandler…</div>
          <h1 className="font-editorial text-4xl mt-4">Vi bekræfter din betaling</h1>
          <div className="mt-8 inline-block w-6 h-6 border-2 border-terracotta border-t-transparent animate-spin rounded-full"></div>
        </>
      ) : (
        <>
          <h1 className="font-editorial text-4xl">Der opstod en fejl</h1>
          <p className="mt-4 text-ink/70">Prøv igen, eller kontakt danamarksolidaritet@gmail.com</p>
        </>
      )}
    </div>
  );
}
